import { computed, ref, unref } from '@nuxtjs/composition-api'
import { MaybeRef } from '@vueuse/core'

import CustomSelectItem from '@/interfaces/CustomSelectItem'
import IdNameObject from '@/interfaces/IdNameObject'

import ggoApi from '~/modules/ggo-api'

type List = CustomSelectItem['value'][]

export default function (
  url: string,
  list: MaybeRef<List> = [],
  selectedValue: MaybeRef<List> = []
) {
  /** 完整的選項列表 */
  const fullList = ref<CustomSelectItem[]>([])

  ggoApi.request<IdNameObject[]>({
    url: ggoApi.prefix + url,
    method: 'GET',
  }).then(({ success, data }) => {
    if (success && data) {
      fullList.value = data.map(({ id, name }): CustomSelectItem => ({ value: id, name }))
    }
  })

  /** 會顯示的項目列表 */
  const availableList = computed(() =>
    fullList.value.filter(({ value }) =>
      [...unref(list), ...unref(selectedValue)].includes(value)
    )
  )

  return {
    fullList,
    availableList,
  }
}
